import script from "./TimeEstimate.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimeEstimate.vue?vue&type=script&setup=true&lang=ts"

import "./TimeEstimate.vue?vue&type=style&index=0&id=5935b8d5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5935b8d5"]])

export default __exports__